import {DlRadioSelectOption, enumContainer, utils} from '@wallaby-ui/core';
import {sortBy} from 'lodash';
import * as React from 'react';
import {useMemo} from 'react';
import {useIntl} from 'react-intl';
import {Options} from 'react-select';

import {
  FilterNodeTypeRadio,
  FilterNodeTypeRadioOwnProps,
} from './FilterNodeTypeRadio';
import {useAppSelector} from 'src/js/store_hooks';

interface OwnProps extends FilterNodeTypeRadioOwnProps {}

type Props = Omit<OwnProps, 'options'>;

export const FilterNodeTypeRadioEnum: React.FC<Props> = (props) => {
  const {node, ...restProps} = props;
  const intl = useIntl();
  const enumName = node.getEnumName();
  const enumMap = useAppSelector(
    (state) => state[enumContainer.ENUM_REDUCER_STATE_ID].enumMap
  );
  const options = useMemo<Options<DlRadioSelectOption>>(() => {
    return sortBy(
      enumMap[enumName] &&
        enumMap[enumName].map((item) => {
          const translatedLabel = utils.TranslateUtils.translate(
            item.messageKey,
            intl
          );
          return {name: item.name, label: translatedLabel};
        }),
      'label'
    );
  }, [enumMap, enumName, intl]);

  return <FilterNodeTypeRadio node={node} {...restProps} options={options} />;
};

FilterNodeTypeRadioEnum.displayName = 'FilterNodeTypeRadioEnum';
